<style>.ratings-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.ratings-item {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rating-source {
  display: flex;
  align-items: center;
}

.rating-source img {
  width: 100%;
  height: 40px;
}

.rating-stars {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rating-stars span {
  margin: 0 5px;
}

.rating-review {
  font-size: 14px;
}</style>
<template>  <div class="ratings-container">
    <div class="ratings-item">
      <a :href="url">
          <div class="rating-source">
            <img :src="icon" :alt="source" />
          </div>
      </a>
      <div class="rating-stars">
          <span>
              <i class="fa fa-star">★</i>
              <i class="fa fa-star">★</i>
              <i class="fa fa-star">★</i>
              <i class="fa fa-star">★</i>
              <i class="fa fa-star">★</i>
          </span>
          <span>{{stars}} av 5</span>
      </div>
    </div>
  </div></template>
<script>export default {
  name: "StarRating",
  props: {
    source: {
      title: 'Källa',
      type: String,
      default: "",
    },
    url: {
      title: 'Länk',
      type: String,
      default: "",
    },
    icon: {
      title: 'Ikon',
      type: String,
      default: "",
    },
    stars: {
      title: 'Stjärnor',
      type: Number,
      default: 5,
    },
  },
};</script>